import getStore from '../store/index.js';
import { getMyProperties } from '../apis/rpm.js';
import { actions as propertyActions } from '../store/state/properties.js';

const BATCH_SIZE = 30;

export async function loadAllProperties() {
  const store = getStore();
  store.dispatch(propertyActions.START_LOADING());
  const state = store.getState();
  const newBatch = await getMyProperties(
    state.properties.list.length,
    BATCH_SIZE
  );
  store.dispatch(propertyActions.NEW_BATCH(newBatch));
  if (newBatch.length === BATCH_SIZE) {
    return loadAllProperties();
  } else {
    store.dispatch(propertyActions.FINISHED_LOADING());
  }
}
